import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export function GetFormatedTimeDiff(time: number, standard: number): string {
    var diff = (time - standard);

    const negative = diff < 0;

    diff = Math.abs(diff);

    const formattedTime = GetFormatedTime(diff);

    return (negative ? "-" : "+") + formattedTime;
}

export function GetFormatedTime(time: number): string {
    var minutes = Math.floor(time / 60000);
    var seconds = ((time % 60000) / 1000);

    var minutesString = minutes > 0 ? minutes + ":" : "";
    const secondsPadding = minutes > 0 ? 5 : 0;

    return minutesString + seconds.toFixed(2).padStart(secondsPadding, "0");
}

export const getTranslatedCompetitionName = (competitionNameToTranslate: string) => {
    return competitionNameToTranslate.replace("Papillon", "butterfly")
        .replace("Libre", "freestyle")
        .replace("Brasse", "breaststroke")
        .replace("Dos", "backstroke")
        .replace("QNI", "medley");
}

export const getCompetitionName = (competition: number, style: string) => {
    return `${competition}m ${style}`;
};

export const convertTimeToMs = (time: string): number => {
    var parsedTime: dayjs.Dayjs;
    if (time.indexOf(':') > 0)
        parsedTime = dayjs(time, "mm:ss,SS");
    else
        parsedTime = dayjs(time, "ss,SS");
    
    return (parsedTime.minute() * 60000) + (parsedTime.second() * 1000) + parsedTime.millisecond();
}

export const isStandardColumn = (field: string) => {    
    return field.startsWith("A") || field === "Open" || field === "Junior" || field === "Senior" || field === "UsportSCM";
}